<span *ngIf="classe"> {{classe.classe_nom}} </span>
